exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.issues-container[data-v-4c1c4f49] {\n  background-color: #F5E6FE;\n  padding-bottom: 160px;\n}\n.card-margin[data-v-4c1c4f49] {\n  margin-top: 106px;\n}\n.issues-card-container[data-v-4c1c4f49] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: space-evenly;\n      -ms-flex-pack: space-evenly;\n          justify-content: space-evenly;\n  width: 95%;\n  margin: auto;\n}\n@media screen and (max-width: 480px) {\n.issues-container h3 br[data-v-4c1c4f49] {\n    display: none;\n}\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4c1c4f49","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/LP/Issues.vue
// module id = QUPr
// module chunks = 3